var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.22 172.812C377.063 164.938 368.907 160 360.001 160H203.438L254.282 32.906C257.251 25.531 256.345 17.125 251.876 10.531S239.97 0 232.001 0H56.001C43.97 0 33.813 8.906 32.22 20.844L0.22 260.844C-0.718 267.688 1.376 274.594 5.938 279.812C10.501 285 17.095 288 24.001 288H170.313L128.532 482.969C126.126 494.187 132.001 505.531 142.532 510.062C145.595 511.375 148.813 512 152.001 512C159.72 512 167.22 508.25 171.813 501.562L379.813 197.562C384.845 190.219 385.376 180.688 381.22 172.812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltLightning);
export default __webpack_public_path__ + "static/media/bolt-lightning.2371f6be9a680c7bdbe8f57de93636be.svg";
export { ForwardRef as ReactComponent };